module.exports = __webpack_public_path__ + "img/img_4.5b673255.png";